import { Tooltip, Typography } from '@bolteu/clay-react';
import InfoCircle from '@bolteu/kalep-react-icons/dist/InfoCircle';

import { TierBenefitId } from '../tierBenefits';
import { DisplayTier } from '../types';
import { BenefitsProgress } from './BenefitsProgress';
import { TierMedal } from './TierMedal';

export interface PerformerStatusProps<T extends DisplayTier> {
  tier: T;
  caption: string;
  /** Shown behind an info icon next to the caption. */
  captionTooltip?: string;
  tierLabelKeys: Record<T, string>;
  benefitLabelKeys: Record<TierBenefitId, string>;
}

export function PerformerStatus<T extends DisplayTier>({
  tier,
  caption,
  captionTooltip,
  tierLabelKeys,
  benefitLabelKeys,
}: PerformerStatusProps<T>) {
  const displayTier: DisplayTier = tier;

  return (
    <div className="flex flex-col items-center self-center gap-4 w-full">
      <div className="flex gap-1.5 items-center justify-center">
        <Typography className="bolt-font-body-m-accent">{caption}</Typography>
        {captionTooltip ? (
          <Tooltip.Root>
            <Tooltip.Trigger
              render={
                <span className="inline-flex items-center">
                  <InfoCircle className="size-4 text-tertiary" />
                </span>
              }
            />
            <Tooltip.Portal>
              <Tooltip.Positioner side="top" sideOffset={4}>
                <Tooltip.Popup>
                  {captionTooltip}
                  <Tooltip.Arrow />
                </Tooltip.Popup>
              </Tooltip.Positioner>
            </Tooltip.Portal>
          </Tooltip.Root>
        ) : null}
      </div>

      <TierMedal tier={tier} size="large" tierLabelKeys={tierLabelKeys} />

      {displayTier === 'ineligible' ? null : (
        <BenefitsProgress tier={displayTier} benefitLabelKeys={benefitLabelKeys} />
      )}
    </div>
  );
}
